import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventStatus } from 'globals/store/events.data';
import { colorsByStatus } from '../../store/performers.era';
import { allEventsStatusReselector, eventStatusReselector } from '../../store/reselectors/events.reselector';
import { Wrapper } from '../wrapper.component';
import { JoiEvent } from 'src/app/store/events.era';
import { hasProgramPermissionsReselector } from '../../store/reselectors/permissions.reselector';
import { OnInit } from '@angular/core';
import { TrafficLightComponent } from '../misc/traffic-light.component';
import { CommonModule } from '@angular/common';
import { TrafficLightDropdownComponent } from '../misc/traffic-light-dropdown.component';

@Component({
    selector: 'event-status',
    template: `
<traffic-light *ngIf="dotOnly" [color]="colorsByStatus[status]"></traffic-light>
<traffic-light-dropdown
  *ngIf="!dotOnly"
  [selected]="tempStatus || status"
  [colorObject]="colorsByStatus"
  [selections]="statusOptions"
  [readOnly]="readOnly || (!hasPermission && !outsideEvent)"
  (select)="setEventStatus($event)"
></traffic-light-dropdown>
`,
    styles: [`

`],
    standalone: true,
    imports: [TrafficLightComponent, CommonModule, TrafficLightDropdownComponent],
})
export class EventStatusComponent extends Wrapper<EventStatusComponent> implements OnInit {
  @Input() dotOnly = true
  @Input() outsideEvent = false
  @Input() eventId: string
  @Input() readOnly = false

  hasPermission = false

  event: JoiEvent
  statusOptions: EventStatus[] = ['Pending', 'Confirmed', 'Cancelled']
  status: EventStatus
  colorsByStatus = colorsByStatus
  tempStatus: EventStatus
  @Output() changeStatus: EventEmitter<EventStatus> = new EventEmitter()

  constructor() {
    super()
  }

  ngOnInit() {
    if (this.outsideEvent) this.selectProp(allEventsStatusReselector, this.eventId, 'status')
    else {
      this.selectProp(eventStatusReselector, true, 'status')
      this.selectProp(hasProgramPermissionsReselector, null, 'hasPermission')
      this.subProp(this.store.select('events', 'event'), 'event')
    }
  }

  setEventStatus(status: string) {
    if (this.outsideEvent) {
      this.tempStatus = status as EventStatus
      this.changeStatus.emit(this.tempStatus)
      return
    }
    const eventStatus = status as Exclude<EventStatus, 'Completed'>
    this.eventService.updateEvent(this.event.eventId,  { eventStatus })
  }
  
}



